export default function SpacerBlock({ settings }) {
  const spacerStyle = {
    height: settings.height,
    backgroundColor: settings.backgroundColor || 'transparent'
  }

  return <div style={spacerStyle}></div>
}
